import {
  getProjectTimers,
  getAllProjectActivities,
} from 'features/projects/activities/activities.actions';

import { getAllDepartments } from 'app/app.actions';
import activitiesService from 'services/activities.service';
import { getAllTasks } from 'features/projects/tasks/tasks.actions';
import { REPORT_ACTIONS } from 'features/projects/report/report.constants';
import { getAllProjectNonProductives } from 'features/projects/npt/npt.actions';
import reportsService from 'services/reports.service';
import { NOTIFICATION_VARIANTS } from 'app/app.constants';
import { getProjectById } from 'features/projects/projects.actions';
import { addNotification } from 'altus-redux-middlewares';

export const onLoad = (projectId) => (dispatch) => {
  dispatch({
    type: REPORT_ACTIONS.PROJECT_REPORT_PAGE_LOADED,
    payload: () =>
      Promise.all([
        dispatch(getProjectById(projectId)),
        dispatch(getAllTasks(projectId)),
        dispatch(getProjectTimers(projectId)),
        dispatch(getAllProjectActivities(projectId)),
        dispatch(getAllProjectNonProductives(projectId)),
        dispatch(getAllDepartments()),
      ]),
  });
};

export const onUnload = () => (dispatch) =>
  dispatch({
    type: REPORT_ACTIONS.PROJECT_REPORT_PAGE_UNLOADED,
  });

export const downloadEndOfJobReport =
  ({ projectExternalId }) =>
    (dispatch) => {
      const payload =
        reportsService.downloadEndOfJobReportAsPdf(projectExternalId);

      dispatch({
        type: REPORT_ACTIONS.PROJECT_REPORT_END_OF_JOB,
        payload,
        notification: {
          [NOTIFICATION_VARIANTS.ERROR]: 'No report found for this project',
        },
      });
    };

export const downloadEndOfJobReportAsExcel =
  ({ projectExternalId }) =>
    (dispatch) => {
      dispatch({
        type: REPORT_ACTIONS.PROJECT_REPORT_END_OF_JOB_AS_EXCEL,
        payload: () =>
          reportsService
            .downloadEndOfJobReportAsExcel(projectExternalId)
            .catch(async (error) => {
              const message = await extractApiErrorMessage(error);

              dispatch(
                addNotification({
                  message,
                  variant: NOTIFICATION_VARIANTS.ERROR,
                }),
              );
            }),
      });
    };

export const getTaskActivities = (projectId, taskId) => (dispatch) => {
  const payload = activitiesService.allActivitiesForTask(projectId, taskId);

  dispatch({
    taskId,
    type: REPORT_ACTIONS.PROJECT_REPORT_GET_ACTIVITIES,
    payload,
  });

  return payload;
};


const extractApiErrorMessage = async (error) => {
  const res = error?.response;
  const body = res?.body ?? res?.data;

  if (body instanceof Blob) {
    const text = await body.text();
    try {
      const json = JSON.parse(text);
      return (
        json?.message ||
        json?.errors?.[0] ||
        json?.Errors?.[0] ||
        'An error has occurred'
      );
    } catch {
      return text || 'An error has occurred';
    }
  }

  return (
    res?.data?.message ||
    body?.message ||
    body?.errors?.[0] ||
    body?.Errors?.[0] ||
    'No report found for this project'
  );
};
